import React, {Fragment, memo} from 'react';

import {ToggleActiveLink} from 'app/components/general/ToggleActiveLink';
import * as urls from 'app/urls';
import {getLocation} from 'app/utils/urls';

export type TagItemType = {
  html_url: string;
  name: string;
};

type Props<T> = {
  items: Array<T>;
  redirectToDashboard?: boolean;
  icon?: string;
  getName?: ({item}: {item: T}) => JSX.Element;
};

export const Tags = memo(function InnerTags<T extends TagItemType>({
  items,
  getName,
  icon,
  redirectToDashboard,
}: Props<T>) {
  if (!items || !items.length) {
    return null;
  }

  return (
    <Fragment>
      {items.map((item) => {
        const link = getLocation(item.html_url);
        return (
          <ToggleActiveLink
            key={item.html_url}
            className="badge mr-1 d-inline"
            inactiveClassName="badge-light"
            activeClassName="badge-secondary"
            to={link.pathname + link.search}
            activeTo={
              redirectToDashboard === true
                ? urls.PROCEDURES_HOME
                : link.pathname + link.search
            }
          >
            {icon != null ? (
              <Fragment>
                <i className={`fa fa-fw ${icon}`} />{' '}
              </Fragment>
            ) : null}
            {getName !== undefined
              ? getName({
                  item,
                })
              : item.name}
          </ToggleActiveLink>
        );
      })}
    </Fragment>
  );
}) as <T extends TagItemType>(props: Props<T>) => JSX.Element;
